import { Timestamp } from 'firebase/firestore';

// Format date from Firestore Timestamp
export const formatDate = (timestamp: Timestamp | null | undefined, locale = 'en-US'): string => {
  if (!timestamp) return '';
  
  const date = timestamp.toDate();
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(date);
};

// Format date without time
export const formatDateOnly = (timestamp: Timestamp | null | undefined, locale = 'en-US'): string => {
  if (!timestamp) return '';
  
  const date = timestamp.toDate();
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }).format(date);
};

// Format number with commas
export const formatNumber = (num: number): string => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

// Truncate text with ellipsis
export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

// Convert hex color to RGB
export const hexToRgb = (hex: string): { r: number; g: number; b: number } | null => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null;
};

// Convert hex color to format Vanta expects (0xRRGGBB)
export const hexToVantaColor = (hexColor: string): number => {
  // Remove # if present
  if (hexColor.startsWith('#')) {
    hexColor = hexColor.substring(1);
  }
  
  // Convert to number
  return parseInt(hexColor, 16);
};